import { Component, Input, OnChanges, OnDestroy } from '@angular/core';
import { LoadingEntity } from '@inst-iot/bosch-angular-ui-components';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FleetChargingFigureService } from 'src/app/_services/fleet-charging-figure.service';
import { FleetChargingInsightsService } from 'src/app/_services/fleet-charging-insights.service';
import { BatteryTypeOption, toBatteryTypeFilter, toBatteryTypeSeries } from 'src/app/_shared/utils/battery-type';

export interface ChargedEnergyRow {
  label: string;
  chargedEnergy: number | undefined;
}

@Component({
  selector: 'app-charging-fleet',
  templateUrl: './charging-fleet.component.html',
  styleUrls: ['./charging-fleet.component.scss']
})
export class ChargingFleetComponent implements OnChanges, OnDestroy {
  private readonly unsubscribe$ = new Subject<void>();
  @Input() fleetId: string[] = [];
  @Input() selectedBatteryTypes: BatteryTypeOption[] = [];
  dataLoading: boolean = false;
  chargedEnergyRows: ChargedEnergyRow[] = [];
  stateOfChargeEventsDatapoints: any = {};
  stateOfChargeDatapoints: any = {};
  errorMessageSocEvents: boolean = false;
  dataLoadingSocEvents: boolean = false;
  errorMessageSoc: boolean = false;
  dataLoadingSoc: boolean = false;
  loader = new LoadingEntity;
  
  constructor(
    private readonly fleetChargingFigureService: FleetChargingFigureService,
    private readonly fleetChargingInsightsService: FleetChargingInsightsService
  ) {}

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
  
  ngOnChanges(): void {
    const batteryTypeFilter = toBatteryTypeFilter(this.selectedBatteryTypes);

    // API request for Charged Energy (Accumulated)
    this.dataLoading = true;
    this.chargedEnergyRows = [];
    this.fleetChargingInsightsService.getChargedEnergyFleet(this.fleetId, batteryTypeFilter).pipe(takeUntil(this.unsubscribe$)).subscribe(
      {
        next: (data: any) => {
          this.chargedEnergyRows = toBatteryTypeSeries(data, this.selectedBatteryTypes).map((series) => ({
            label: series.label,
            chargedEnergy: series.datapoints[0]?.chargedEnergy
          }));
        },
        error: (error) => {
          console.error('Error fetching Charged Energy Fleet data:', error);
          this.dataLoading = false;
        },
        complete: () => {
          this.dataLoading = false;
        }
      }
    )
    
    // API request for Low/High State of Charge Events
    this.dataLoadingSocEvents = true;
    this.errorMessageSocEvents = false;
    this.fleetChargingFigureService.getStateOfChargeEventsFleet(this.fleetId, batteryTypeFilter).pipe(takeUntil(this.unsubscribe$)).subscribe(
      {
        next: (datapoints) => {
          this.stateOfChargeEventsDatapoints = datapoints;
        },
        error: (error) => {
          console.error('Error fetching State of Charge Events Fleet data:', error);
          this.dataLoadingSocEvents = false;
          this.errorMessageSocEvents = true;
        },
        complete: () => {
          this.dataLoadingSocEvents = false;
        }
      }
    )
    
    // API request for Initial/End State of Charge
    this.dataLoadingSoc = true;
    this.errorMessageSoc = false;
    this.fleetChargingFigureService.getStateOfChargeFleet(this.fleetId, batteryTypeFilter).pipe(takeUntil(this.unsubscribe$)).subscribe(
      {
        next: (datapoints) => {
          this.stateOfChargeDatapoints = datapoints;
        },
        error: (error) => {
          console.error('Error fetching State of Charge Fleet data:', error);
          this.dataLoadingSoc = false;
          this.errorMessageSoc = true;
        },
        complete: () => {
          this.dataLoadingSoc = false;
        }
      }
    )
    
  }
}